<template>
  <v-switch
    :items="cargo_container_status"
    :label="`Container status: ${model?'Full':'Empty'}`"

    v-model="model"
  />
</template>

<script>

export default {
  name: 'ContainerTypeSelector',
  data: () => ({
    cargo_container_status: [
      'Full',
      'Empty',
    ],
  }),
  props: {
    model: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>

</style>
